import { SkeletonBlock, SkeletonText, Spacer } from "@zapier/design-system";
import classNames from "classnames";
import styles from "./ZapPreview.module.css";

export function ZapPreviewLoader() {
  return (
    <div className={classNames(styles.zapPreview, styles.loading)}>
      <div className={styles.zapPreviewIconsRow}>
        {[{ id: "1" }, { id: "2" }].map((step) => (
          <span key={step.id}>
            <SkeletonBlock borderRadius="medium" height="40px" width="40px" />
          </span>
        ))}
      </div>
      <SkeletonText textAlign="left" lines={1} size="heading" width="100%" />
      <Spacer height={10} />
      <SkeletonText textAlign="left" lines={2} size="heading" width="100%" />
    </div>
  );
}
